import React, { useState } from 'react';
import {
  View, Text, StyleSheet, ViewStyle,
} from 'react-native';
import Colors from '../../../constants/Colors';
import DateLabel from '../DateLabel';
import TimeTile from './components/TimeTile';
import ScrollViewStyled from '../../ScrollViewStyled';

// eslint-disable-next-line no-unused-vars, no-shadow
export enum TimeWidgetSize { WIDE_MEDIUM, WIDE_LARGE, NARROW_LARGE, NARROW_MEDIUM, SINGLE }

type TimeItem = {
  title?: string,
  time?: string,
  percentage?: number,
}

interface TimesDashboardProps {
  style?: ViewStyle,
  title?: string,
  data?: TimeItem[],
  size?: TimeWidgetSize,
}

const TimesDashboard = ({
  style, title = 'Name', data = [
    { title: 'Title', time: '00:00', percentage: 100 },
    { title: 'Title', time: '00:00', percentage: 100 },
    { title: 'Title', time: '00:00', percentage: 100 },
    { title: 'Title', time: '00:00', percentage: 100 },
    { title: 'Title', time: '00:00', percentage: 100 },
    { title: 'Title', time: '00:00', percentage: 100 },
    { title: 'Title', time: '00:00', percentage: 100 },
    { title: 'Title', time: '00:00', percentage: 100 },
    { title: 'Title', time: '00:00', percentage: 100 },
  ], size = TimeWidgetSize.WIDE_MEDIUM,
}: TimesDashboardProps) => {
  if (!(data?.length > 0)) return null;
  const [containerWidth, setContainerWidth] = useState<number>(0);
  const height: number = (containerWidth - 72) / 4;
  const renderSingle: boolean = size === TimeWidgetSize.SINGLE;
  const renderTwoRows: boolean = (size === TimeWidgetSize.WIDE_MEDIUM && data.length > 3)
    || (size === TimeWidgetSize.NARROW_MEDIUM && data.length > 6);
  const narrow: boolean = [TimeWidgetSize.NARROW_MEDIUM, TimeWidgetSize.NARROW_LARGE]
    .includes(size);
  const wide: boolean = [TimeWidgetSize.WIDE_LARGE, TimeWidgetSize.WIDE_MEDIUM].includes(size);
  const splitIndex: number = Math.floor((data.length + 1) / 2);

  return <View
    style={[
      styles.container,
      narrow && styles.containerNarrow,
      wide && styles.containerWide,
      size !== TimeWidgetSize.SINGLE && { height },
      style,
    ]}
    onLayout={({ nativeEvent: { layout: { width } } }) => setContainerWidth(width)}
  >
    {title.length > 0 && <Text style={styles.title}>{title}</Text>}
    <DateLabel style={styles.date} />
    {renderSingle ? <TimeTile
      title={data[0].title}
      time={data[0].time}
      percentage={data[0].percentage}
      style={styles.itemSingle}
    /> : <ScrollViewStyled
      horizontal
      style={styles.scrollView}
      contentContainerStyle={{ justifyContent: 'center' }}
    >
      <View>
        <View style={styles.list}>
          {data.slice().splice(0, renderTwoRows ? splitIndex : data.length)
            .map(({ title: itemTitle, time, percentage }: TimeItem, index: number) => <>
              {index > 0 && <View style={styles.itemSeparator} />}
              <TimeTile
                {...{ time, percentage }}
                title={itemTitle}
                style={[
                  styles.itemMedium,
                  size === TimeWidgetSize.WIDE_LARGE && styles.itemLarge,
                  narrow && styles.itemNarrow,
                  size === TimeWidgetSize.NARROW_LARGE && styles.itemLarge,
                ]}
              />
            </>)}
        </View>
        {renderTwoRows && <View style={[styles.list, styles.secondRow]}>
          {data.splice(splitIndex)
            .map(({ title: itemTitle, time, percentage }: TimeItem, index: number) => <>
              {index > 0 && <View style={styles.itemSeparator} />}
              <TimeTile
                {...{ time, percentage }}
                title={itemTitle}
                style={[
                  styles.itemMedium, size === TimeWidgetSize.NARROW_MEDIUM && styles.itemNarrow,
                ]}
              />
            </>)}
        </View>}
      </View>
    </ScrollViewStyled>}
  </View>;
};

const styles = StyleSheet.create({
  container: {
    borderRadius: 16,
    borderWidth: 1,
    borderColor: Colors.light.hereworksBlue50,
    backgroundColor: '#FFF',
    padding: 16,
    marginBottom: 40,
    alignSelf: 'flex-start',
  },
  containerNarrow: {
    // width: 542,
    width: '100%',
  },
  containerWide: {
    width: '100%',
  },
  title: {
    fontSize: 18,
    lineHeight: 27,
    color: Colors.light.hereworksBlack600,
    fontFamily: 'Poppins_400Regular',
    marginBottom: 4,
  },
  date: {
    marginBottom: 24,
  },
  list: {
    flexDirection: 'row',
    minWidth: '100%',
    flex: 1,
  },
  itemMedium: {
    maxHeight: 210,
  },
  itemLarge: {
    maxHeight: 435,
  },
  itemNarrow: {
    width: 160,
  },
  itemSingle: {
    width: 227,
  },
  itemSeparator: {
    marginHorizontal: 8,
    backgroundColor: Colors.light.hereworksBlue50,
    width: 1,
  },
  secondRow: {
    marginTop: 16,
    paddingTop: 8,
    borderTopWidth: 1,
    borderTopColor: Colors.light.hereworksBlue50,
  },
  scrollView: {
    flex: 1,
    alignSelf: 'stretch',
  },
});

export default TimesDashboard;
